// extracted by mini-css-extract-plugin
export default {"Modal":"QNeNRvfFBDyhe5dZ0Nl6","backdrop":"XBRAGbig32uBpAud40_R"};